<mat-dropdown [options]="dropdownOptions" [configurationInput]="dropdownConfiguration" [formControl]="formControl()">
</mat-dropdown>
